import { Logger, LoggerRole } from '@zep/logger';
export interface GA4LoggerOptions {
  dispatch: (eventName: string, params: Record<string, unknown>) => void;
  role?: LoggerRole;
}

const GA4_GLOBAL_STATE_ALLOWLIST = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
] as const;

const pickGA4GlobalState = (globalState: Record<string, unknown>) =>
  Object.fromEntries(
    GA4_GLOBAL_STATE_ALLOWLIST.flatMap(key =>
      key in globalState ? [[key, globalState[key]]] : [],
    ),
  );

export class GA4Logger implements Logger {
  public name = 'ga4';
  public role: LoggerRole;
  private _dispatch: GA4LoggerOptions['dispatch'];

  constructor(options: GA4LoggerOptions) {
    this._dispatch = options.dispatch;
    this.role = options.role ?? 'tracking';
  }

  mapEventParams: Logger['mapEventParams'] = ({
    globalState,
    eventParams,
  }) => ({
    ...pickGA4GlobalState(globalState),
    ...eventParams,
  });

  log: Logger['log'] = (message, params) => {
    this._dispatch(message, (params ?? {}) as Record<string, unknown>);
  };
}
